import React from 'react';
import { TextField, NumericFormat, TextFieldProps } from '@qbe/ads-core';
import { InputAttributes } from 'react-number-format';

type PrefixedTextFieldType = React.ComponentType<InputAttributes> | undefined;

const PrefixedTextField = (props: TextFieldProps) => {
  return <TextField prefix="$" {...props} />;
};

const CurrencyTextField = (props: TextFieldProps) => {
  return (
    <NumericFormat
      customInput={PrefixedTextField as PrefixedTextFieldType}
      autoComplete=""
      thousandSeparator
      allowNegative={false}
      decimalScale={2}
      fixedDecimalScale={true}
      type="text" // required as NumericFormat `type` is more restrictive than TextField's
      {...props}
    />
  );
};

export default CurrencyTextField;
